import {
  ForwardRefExoticComponent,
  MutableRefObject,
  RefAttributes,
  forwardRef,
} from 'react';
import { ContentDiv } from './ModalContent.styles';

interface ModalContentProps {
  children: React.ReactNode;
  removePadding?: boolean;
  isSafari?: boolean;
  desktopHeight?: string; // sets height for desktop view if footer has a different (not handled) height
  mobileHeight?: string; // sets height for mobile view if footer has a different (not handled) height
}

export function ModalContentFunction(
  props: ModalContentProps,
  ref: MutableRefObject<HTMLDivElement>,
) {
  const {
    children,
    removePadding = false,
    desktopHeight = null,
    mobileHeight = null,
    isSafari = false,
  } = props;
  return (
    <ContentDiv
      removePadding={removePadding}
      desktopHeight={desktopHeight}
      mobileHeight={mobileHeight}
      isSafari={isSafari}
      ref={ref}
    >
      {children}
    </ContentDiv>
  );
}

type IModalContent = ForwardRefExoticComponent<
  ModalContentProps & RefAttributes<unknown>
>;

export const ModalContent: IModalContent = forwardRef(ModalContentFunction);
